<template>
<!--  <validation-provider v-slot="validationContext" vid="dob" name="Date of Birth" rules="required">-->
<!--    <b-form-group :label="label" label-for="dob-input" :invalid-feedback="validationContext.errors[0]" :state="getValidationState(validationContext)">-->
      <b-input-group class="mb-1">
        <b-form-input
            id="dob-input"
            v-model="dob"
            v-mask="dob ? '##/##/####' : null"
            type="text"
            placeholder="MM/DD/YYYY"
            autocomplete="off"
            :disabled="disabled"
            :state="validationState"
            @change="onUpdate">
        </b-form-input>
        <b-input-group-append>
          <b-form-datepicker
              v-model="cal"
              :disabled="disabled"
              button-only
              :button-variant="variant"
              :today-button="false"
              right
              locale="en-US"
              size="sm"
              placeholder="MM-DD-YYYY"
              aria-controls="dob-input"
              :hide-header="true"
              label-no-date-selected=""
              :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
              :initial-date="initialDOB"
              :date-disabled-fn="disabledDOB"
              :state="validationState"
              @shown="onShown"
              @context="onContext"/>
        </b-input-group-append>
      </b-input-group>
<!--    </b-form-group>-->
<!--  </validation-provider>-->
</template>

<script>
import { VueMaskDirective } from 'v-mask';
import { validate } from 'vee-validate';

export default {
  name: 'DateOfBirth',
  directives: { mask: VueMaskDirective },
  props: {
    value: {
      type: [String],
      required: true
    },
    disabled: {
      type: Boolean,
      default: true
    },
    variant: {
      type: String,
      default: 'primary'
    },
    label: {
      type: String,
      default: 'Date of Birth'
    },
    studentGrade: {
      type: [String, Number],
      required: false,
      default: 0
    },
    hasFormGroup: {
      type: Boolean,
      default: true
    },
    validationState: {
      type: Boolean,
      default: null
    },
  },
  data() {
    return {
      dob: this.value,
      cal: new Date(this.value)
    }
  },
  computed: {
    initialDOB() {
      const gradeYears = this.studentGrade === 11 ? 17 : 16
      return new Date(new Date().getFullYear() - gradeYears, 0, 1)
    },
  },
  watch: {
    value() {
      this.cal = new Date(this.value)
    }
  },
  methods: {
    disabledDOB(ymd, date) {
      const gradeYears = this.studentGrade === 11 ? 17 : 16
      const currentYear = new Date().getFullYear()
      const year = date.getFullYear()
      return year < (currentYear - gradeYears) || year > (currentYear - gradeYears)
    },
    onUpdate(value) {
      this.$emit('input', this.dob)
    },
    onShown(ctx) {
      this.cal = this.dob ? new Date(this.value) : this.cal
    },
    onCalUpdate(value) {
      this.dob = value
      this.$emit('input', this.dob)
    },
    onContext(ctx) {
      /*if(!this.disabled || (this.disabled && this.dob)) {*/
        this.dob = ctx.selectedFormatted
        this.$emit('input', this.dob)
     /* }*/
    },
  }
}
</script>

<style scoped>

</style>
